import script from "./CategoriesManager.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoriesManager.vue?vue&type=script&setup=true&lang=js"

import "./CategoriesManager.vue?vue&type=style&index=0&id=3bb26a3b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bb26a3b"]])

export default __exports__